import React, { useContext, useEffect, useState } from 'react';
import Input from '../../reusable/Input';
import { ForgotPasswordContext } from '../../../contexts/ForgotPasswordContext';
import history from '../../../history';
import graphQL from '../../../apis/graphQL';
import { Link } from 'react-router-dom';

const TokenPasswordRecovery = () => {

    const { maskedEmail, email, token, setToken } = useContext(ForgotPasswordContext);
    // loading
    const [loading, setLoading] = useState(true);
    // graphQLErrors
    const [graphQLErrors, setGraphQLErrors] = useState(false);

    useEffect(() => {
        if (email === '') {
            history.push('/emailPasswordRecovery');
        } else {
            (async () => {
                setLoading(true);
                const response = await graphQL(`mutation{
                    sendPasswordRecoveryToken(email: "${email}"){
                        success
                        message
                    }
                    }`);
                setLoading(false);
                if (response.sendPasswordRecoveryToken) {

                } else if (response) {
                    setLoading(false);
                }
            })()
        }
    }, [email])

    const continueButtonClicked = async () => {
        setLoading(true);
        const response = await graphQL(`mutation{
            verifyPasswordRecoveryToken(email: "${email}", token: "${token}"){
                success
                message
            }
            }`);
        setLoading(false);
        if (response.verifyPasswordRecoveryToken) {
            history.push('/newPasswordRecovery');
        } else if (response) {
            setLoading(false);
            setGraphQLErrors(response);
        }
    }

    const onChange = (e) => {
        setGraphQLErrors(false);
        setToken(e.target.value);
    }

    return (<div>
        <div className="login-wrapper mt-3">
            <div className="container">
                {/* <!-- Two Factor 		--> */}
                <div className="panel-clear">
                    <div className="row gap-triple">
                        <div className="col">
                            <h2>Password Recovery</h2>
                            <p className="text-center">
                                <img
                                    src="/images/image-password-recovery.png"
                                    alt="Illustration depicting a lock and password"
                                    className="mt-1"
                                />
                            </p>
                        </div>
                        <div className="col-grow-2">
                            <p className="p-primary">
                                A message with a verification code has been sent to your email
                                <span
                                    className="text-spread text-bold"
                                > {maskedEmail} </span>
                            </p>
                            <p className="text-bold mt-2">Enter the code to continue:</p>
                            <form action="password-recovery-reset-password.html" className="mt-3">
                                {/* verificationCode field*/}
                                <Input
                                    type="text"
                                    label="Verification Code:"
                                    id="verificationCode"
                                    placeholder=""
                                    onChange={onChange}
                                    errorMessage={graphQLErrors}
                                />
                                {/* .verificationCode field */}

                                <div className="form-group mt-3">
                                    <Link
                                        to="/forgot-password/method-password-recovery"
                                        className="btn btn-secondary mr-2"
                                    >Cancel</Link>
                                    <button type="button"
                                        className="btn btn-primary"
                                        onClick={continueButtonClicked}
                                    >{loading ? <div className="loader-linear--bg-white"><span></span><span></span><span></span></div> : 'Continue'}
                                    </button>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>);
}

export default TokenPasswordRecovery;